var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('breadcrumb',{staticClass:"breadcrumb-container",attrs:{"id":"breadcrumb-container"}}),_c('h2',[_c('span'),_vm._v(_vm._s(_vm.$route.meta.cardTitle))]),(_vm.$route.meta.showCard)?_c('el-card',{staticClass:"box-card"},[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }